











































import { computed, defineComponent, ref } from '@vue/composition-api'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { SfTabs } from '@storefront-ui/vue';
import { PropType } from 'vue';
import { TabberType } from '~/types/solepro/PageBuilder';

export default defineComponent({
    name: "Tabber",
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object as PropType<TabberType>,
            required: true
        }
    },
    components: {
        PageBuilderComponent,
        SfTabs
    },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        content?.children.forEach((tab, index) => {
            content.children[index].tabId = tab.tabName.replaceAll(' ', '-')
        });
        const selectedTabIndex = ref(0);
        return {
            content,
            selectedTabIndex
        }
    },
    methods: {
        focusNextTrigger(index) {
            const triggers = this.$el.querySelectorAll(".tab-trigger");
            const nextIndex = (index + 1) % triggers.length;
            (triggers[nextIndex] as HTMLElement).focus();
        },

        focusPreviousTrigger(index) {
            const triggers = this.$el.querySelectorAll(".tab-trigger");
            const prevIndex = (index - 1 + triggers.length) % triggers.length;
            (triggers[prevIndex] as HTMLElement).focus();
        },
        handleAccessibilityKeydown(e, index) {
            const isMobile = window.innerWidth <= 1024;

            switch (e.key) {
                case "ArrowLeft":
                    if (isMobile) break;
                    e.preventDefault();
                    this.focusPreviousTrigger(index);
                    break;
                case "ArrowRight":
                    if (isMobile) break;
                    e.preventDefault();
                    this.focusNextTrigger(index);
                    break;
            }
        }
    },
    mounted() {
        const triggers = this.$el.querySelectorAll(".tab-trigger");
        triggers.forEach((trigger, index) => {

            // Handle keyboard interactions
            trigger.addEventListener("keydown", (e) => {
                this.handleAccessibilityKeydown(e, index);
            });
        });

        try{
            (this.$refs.listElement as HTMLElement).setAttribute('aria-labelledby',this.$el.closest('div').querySelector('h2').id)
        }catch(e){}
    }
})
